export enum PaymentSecurityLevel {
    AuthorizedAccountOnly = 0,
    NonAuthorizedAccounts = 1
}
